import { useTranslation } from 'libs/i18n'
import { format } from 'libs/dates'
import { useForm } from 'libs/form'
import { routes } from 'config/routes'
import { BackButton, Form, Header } from 'shared/components'
import { useBookingOptions } from '../../hooks'
import { BookingFormSections } from '../../organisms/BookingForm/BookingFormSections'
import { useAddBookingValidationSchema } from './hooks/useAddBookingValidationSchema'
import { useAddBookingMutation } from './mutations/useAddBookingMutation'

const BookingsAddPage = () => {
	const { t } = useTranslation()
	const validationResolver = useAddBookingValidationSchema()
	const { addBookingMutation, addBookingLoading } = useAddBookingMutation()
	const options = useBookingOptions({ daysLabel: t('days') })

	const form = useForm({
		mode: 'onChange',
		resolver: validationResolver
	})

	const onSubmit = (data: any) => {
		addBookingMutation({
			is_active: true,
			user: +data.user?.value,
			rental: +data.rental?.value,
			start_date: data.from ? format(data.from, 'yyyy-MM-dd') : format(new Date(), 'yyyy-MM-dd'),
			end_date: data.to ? format(data.to, 'yyyy-MM-dd') : undefined,
			booth: +data.booth?.value,
			commission: data.commission,
			payment: {
				status: data.payment?.status?.value,
				method: data.payment?.method?.value
			},
			store_notes: data.store_notes
		})
	}

	return (
		<>
			<Header
				title={t('New booking')}
				eyebrow={t('Bookings')}
				actions={<BackButton to={routes.bookingIndex} text={t('Back to bookings')} />}
			/>
			<div className="px-5 lg:px-0">
				<Form
					variant="sections"
					className="max-w-[960px]"
					submitText={t('Create booking')}
					onSubmit={form.handleSubmit(onSubmit)}
					isLoading={addBookingLoading}>
					<BookingFormSections
						mode="create"
						form={form}
						options={options}
						minStartDate={new Date()}
					/>
				</Form>
			</div>
		</>
	)
}

export default BookingsAddPage
